import React from 'react';
import Img from 'gatsby-image';
import PropTypes from 'prop-types';
import tw, { styled } from 'twin.macro';
import { useStaticQuery, graphql } from 'gatsby';
import { ThemeProvider } from 'styled-components';
import { customContainer } from '@utils/twin-macro';
import { breakpoints } from '@utils/variables';
// eslint-disable-next-line no-unused-vars
import styles from '@components/base.css';

import Cookies from '@components/cookies';
import Header from '@components/header';
import Footer from '@components/footer';
import Copyrights from '@components/copyrights';

const Wrapper = tw.div`overflow-x-hidden`;

const AdjustedContainer = styled.div`
  ${customContainer}
  ${tw`relative lg:pt-90`}
  ${({ moved }) => (!moved && tw`lg:pl-200 lg:pr-190`)}
`;

const Circle = styled.div`
  top: 20px;
  left: -48px;
  ${tw`absolute -z-1 w-340 h-340 opacity-70 bg-pink rounded-full`}

  @media (min-width: 1024px) {
    top: ${({ moved }) => (moved ? 33 : 42)}px;
    left: ${({ moved }) => (moved ? -140 : 0)}px;
  }
`;

const Beans = styled(Img)`
  top: 17px;
  left: -90px;
  ${tw`absolute! w-170`}
  
  @media (min-width: 1024px) {
    top: ${({ moved }) => (moved ? 10 : 190)}px;
    left: ${({ moved }) => (moved ? -160 : -75)}px;
  }
`;

const Mark = styled(Img)`
  ${tw`absolute! hidden lg:block lg:w-190`}
  
  @media (min-width: 1024px) {
    top: 440px;
    right: -270px;
  }
`;

const Concrete = styled(Img)`
  ${tw`absolute! hidden -z-1 lg:block lg:w-595`}

  @media (min-width: 1024px) {
    top: 15px;
    right: -180px;
  }

  @media (min-width: 1460px) {
    ${tw`hidden`}
  }
`;

const ConcreteBig = styled(Img)`
  ${tw`absolute! hidden -z-1`}

  @media (min-width: 1460px) {
    top: 15px;
    right: -730px;
    width: 1130px;
    ${tw`block`}
  }
`;

const LayoutConcrete = ({ children, moved, switchPath }) => {
  const data = useStaticQuery(graphql`
    query {
      concrete: file(relativePath: { eq: "concrete.png" }) {
        childImageSharp {
          fluid(maxWidth: 700) {
            ...GatsbyImageSharpFluid
          }
        }
      },
      concreteBig: file(relativePath: { eq: "concrete-big.png" }) {
        childImageSharp {
          fluid(maxWidth: 1200) {
            ...GatsbyImageSharpFluid
          }
        }
      },
      mark: file(relativePath: { eq: "coffee-mark.png" }) {
        childImageSharp {
          fluid(maxWidth: 250) {
            ...GatsbyImageSharpFluid
          }
        }
      },
      beans: file(relativePath: { eq: "coffee-beans.png" }) {
        childImageSharp {
          fluid(maxWidth: 200) {
            ...GatsbyImageSharpFluid
          }
        }
      },
    }
  `);

  return (
    <ThemeProvider theme={{ breakpoints }}>
      <Wrapper>
        <Cookies />
        <Header switchPath={switchPath} />
        <AdjustedContainer moved={moved}>
          <Circle moved={moved} />
          <Beans fluid={data.beans.childImageSharp.fluid} moved={moved} />
          <Concrete fluid={data.concrete.childImageSharp.fluid} />
          <ConcreteBig fluid={data.concreteBig.childImageSharp.fluid} />
          <Mark fluid={data.mark.childImageSharp.fluid} />
          <main>{children}</main>
        </AdjustedContainer>
        <Footer />
        <Copyrights />
      </Wrapper>
    </ThemeProvider>
  );
};

LayoutConcrete.defaultProps = {
  moved: false,
  switchPath: [],
};

LayoutConcrete.propTypes = {
  children: PropTypes.node.isRequired,
  moved: PropTypes.bool,
  switchPath: PropTypes.arrayOf(PropTypes.string),
};

export default LayoutConcrete;
